import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getLegacyCitas } from '../../helpers/api_helper';

const citasHooks = (fechaInicio, fechaTermino) => {
    const [citas, setCitas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId)
    const empresa = useSelector((state) => state.Context.empresa)
    const departamento = useSelector((state) => state.Context.departamento)

    useEffect(() => {
        const fetchCitas = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await getLegacyCitas({ tenantId, empresa, centroCosto: departamento, fechaInicio, fechaTermino });
                if (Array.isArray(response)) {
                    setCitas(response);
                } else {
                    throw new Error('API returned invalid data format: expected an array');
                }
            } catch (err) {
                setError(`Failed to fetch citas: ${err.message || 'Unknown error'}`);
                setCitas([]);
            } finally {
                setLoading(false);
            }
        };

        if (tenantId && empresa && departamento && fechaInicio && fechaTermino) {
            fetchCitas();
        }
    }, [tenantId, empresa, departamento, fechaInicio, fechaTermino]);

    return { citas, loading, error };
};

export default citasHooks;